/**
 * 세션 만료 상태 관리 스토어
 * 목적: 세션 만료 시 전역 확인 다이얼로그 표시
 */
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useSessionExpiredStore = defineStore('sessionExpired', () => {
  // State
  const isVisible = ref(false);

  // Actions
  function show() {
    isVisible.value = true;
  }

  function hide() {
    isVisible.value = false;
  }

  function handleConfirm() {
    hide();
    sessionStorage.removeItem('auth');
    // 환경에 따른 base URL 적용 (개발: '/', 프로덕션: '/app')
    const config = useRuntimeConfig();
    const baseURL = config.app.baseURL || '';
    window.location.href = `${baseURL}/login`;
  }

  function $reset() {
    isVisible.value = false;
  }

  return {
    // State
    isVisible,
    // Actions
    show,
    hide,
    handleConfirm,
    $reset,
  };
});